import type { TourConfig } from '../../types/tour.types'

const aiAssistantTour: TourConfig = {
  id: 'ai-assistant',
  title: 'Your AI teammate',
  module: 'AI',
  routeName: 'AiAssistant',
  order: 10,
  autoStart: true,
  featureFlag: 'enableAiAssistant',
  steps: [
    {
      id: 'intro',
      title: 'Delegate the busywork',
      body: 'The AI Assistant does real work for you — building lists, cleaning CRM data, and answering questions about your prospects. It can **execute actions**, not just chat, so you learn less and ship more.',
    },
    {
      id: 'suggestions',
      target: '.ai-chat-main__body',
      placement: 'top',
      title: 'Start from a proven prompt',
      body: 'Pick a suggested task or type your own. Good starting points: *"Analyze my CRM data quality"* or *"Find companies like my best customers."*',
    },
    {
      id: 'input',
      target: '.ai-input-wrapper',
      placement: 'top',
      title: 'Ask in plain English',
      body: 'Describe the outcome you want. The assistant will take steps, and **ask for your approval** before anything important — so you stay in control.',
    },
  ],
}

export default aiAssistantTour
